<template>
<div v-if="$store.state.isLoading == false" :class="wrapTableClasses">
  <b-button v-if="settings.development == true" @click="test()">TEST</b-button>
    <input v-if="settings.searchinput == true"
                    class="search"
                    type="text"
                    v-model="searchTermIntern"
                    placeholder="Suche"
            >
    <table class="reportTable" :class="tableClasses" >
        <thead>
            <tr>
                <th v-for="(h, i) in displayedFields" :key="i" :class="h.hclasses" :width="h.width">

                  <div v-if="hasClass(h.hclasses,'rotate')" :style="{ width: h.width }">
                      <span>{{h.label}}</span>
                  </div>
                  <div v-else>
                    <div v-if="typeof h.sortable !== 'undefined' || h.sortable"><span>{{h.label}}</span></div>
                    <div v-else-if="h.type != 'button'" @click="orderBy(h)" :class="[ h.isFiltered == true ? 'isFiltered' : '' ]" class="label sortable"><span>{{h.label}}</span></div>
                    <div v-if="sort.fieldName === h.show && (typeof h.sortable === 'undefined' || !h.sortable) " class="sortdiv"><span :class="sort.order"></span></div>
                  </div>
                  </th>
            </tr>
        </thead>

        <tbody>
            <tr v-if="displayedRows.length == 0" class="no-data"><td :colspan="displayedFields.length">Keine Daten vorhanden</td></tr>
            <tr v-for="(b, i) in displayedRows" :key="i">
              <td v-for="(h, j) in displayedFields" :key="j" :class="colclasses(h, b)">
                <div v-if="h.type == 'button'" @click="clicked(h.event, b)" :title="h.show"><font-icon v-if="h.icon" :icon="h.icon" :class="h.classes"/></div>

                <div v-else-if="h.type == 'check'" @click="clicked(h.event, b, h)" :class="h.classes">
                  <font-icon v-if="b[h.show] == 1" :icon="['far', 'check-square']" class="check"/>
                  <font-icon v-else-if="b[h.show] == 0" :icon="['far', 'square']" class="notcheck"/>
                  <font-icon v-else icon="spinner" spin class="check_load"/>
                </div>

                <span v-else-if="h.iconcolname"><font-icon v-if="b[h.iconcolname].length > 0" :icon="b[h.iconcolname]" :class="h.classes" :style="{ fill: h.fillcolor }" /></span>
                <span v-else-if="h.type == 'info'" :title="b[h.show]" class="info"><font-icon :icon="['fa', 'info']" :class="h.classes"/></span>
                <span v-else-if="h.type == 'title'" class="c" :title="b[h.title]" v-html="highlight(b[h.show], searchTermIntern)">{{b[h.show]}}</span>
                <span v-else class="c" :title="b[h.show]" v-html="highlight(b[h.show], searchTermIntern)">{{b[h.show]}}</span>
                </td>
            </tr>
        </tbody>
    </table>
    <pagination v-if="pagination" :pagination="pagination" @pageChange="pageChange"></pagination>
</div>
</template>

<script>
import EventBus from "../../bus";
import Pagination from "./_BaseTablePagination"
import functions from '../../mixins/functions';

export default {
  name: 'BaseTable',
  mixins: [functions],
  props: {
    settings: {type: Object},
    fields: { type: Array, default: () => [] },
    items: {type: Array, default: () => []},
    sortBy: { type: String, default: '' },
    sortOrder: { type: String, default: '' },
    searchTerm: { type: String, default: '' },
    rowClass: { type: String, default: '' },
    tableClass: { type: String, default: '' },
    striped: { type: Boolean, default: true },
    bordered: { type: Boolean, default: true },
    colstripes: { type: Boolean, default: false},
    outlined: { type: Boolean, default: true },
    hover: { type: Boolean, default: true },
    tableId: { type: String, default: "1"},
  },
  data() {
    return {
      sortedItems: [],
      columns: [],
      rows: [],
      filter: '',
      sort: {
          fieldName: '',
          order: '',
      },
      searchTermIntern: '',
      pagination: {
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
          rowMax: 0
      }
    };
  },
  created() {
      var t = this.timer("created BaseTable");
      this.sort.fieldName = this.sortBy;
      this.sort.order = this.sortOrder;
      this.searchTermIntern = this.searchTerm;      
      if(this.settings.rowMax && this.settings.rowMax > 0){
        this.pagination.rowMax = this.settings.rowMax;
      }
      this.readUrl();  


  },
  mounted() {
     var t = this.timer("mounted")  
     EventBus.$on("resetFilterClicked", () => {
      this.searchTermIntern = "";
    });
    t.stop()
  },
  computed: {
    displayedFields() {
      var t = this.timer("displayedFields"); 
      var fields = [];
      if(this.fields && this.fields.length > 0){
          fields = this.fields; 
          return fields;
      }
      if( (!fields || fields.length == 0) && this.items && this.items.length > 0 ){
            fields = []
            for (var show in this.items[0]) {
              if(!show.endsWith("_c")){
                var col = {};
                col.label = convertHeaderName( show );
                col.show = show;
                fields.push(col);
              } 
            }
      }
      t.stop();
      return fields;
    },
    
    tableClasses() {
      return ['table', 'reportTable', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : ''
                                   , this.bordered ? 'table-bordered' : '', this.outlined ? 'border' : '', this.colstripes ? 'colstripes' : ''
                                   , this.tableClass];
    },
    wrapTableClasses(){
      return ['reportTableWrap',  this.bordered ? 'test' : 'table-not-bordered'];
    },
    displayedRows() {
        var t = this.timer("displayedRows"); 
        //this.setFilter();
        if( this.pagination.rowMax > 0 ){
          t.stop();
          let start = ((this.pagination.currentPage-1) * this.pagination.rowMax);
          let end = this.pagination.rowMax * this.pagination.currentPage;
          return this.sortedItems.slice(start, end);
        }
        t.stop()
        return this.sortedItems;   
    }
  },
  methods: {
    colclasses(field, row){
      var returnValue = Object.assign([], field.classes)
      if(typeof field.colclass != 'undefined'){
        returnValue.push(row[field.colclass]);
      }
      return returnValue
    },
    hasClass(cc, c){
      return Array.isArray(cc) && cc.find(x => x === c)
    },
    test: function(){
      
      console.log(this.fields)
      console.log(this.rows)
    },
    clicked(eventName, item, item2){
      EventBus.$emit(eventName, item, item2);
    },
    pageChange(page) {
        this.pagination.currentPage = page
        this.updateUrl()
    },
    UpdatePagination: function(){
      if(this.pagination.rowMax > 0){
        this.pagination.totalPages = Math.ceil(this.sortedItems.length / this.pagination.rowMax)
      }
      this.pagination.totalItems = this.sortedItems.length
    },
    setFilter: function(){
      var t = this.timer("setFilter");
      const s = this.searchTermIntern.toUpperCase()
      const f = this.fields
      this.pagination.currentPage = 1

      var tmp = this.rows.filter(function(item){
        let found = true;
        f.forEach(function(field){
            if( item[field.show] ){
                if(field.isFiltered){
                  if( field.notSelected.includes(item[field.show]) ){
                    found = false
                    return
                  }
                }
            }
          });
        return found
      });

      this.sortedItems = tmp.filter(function(item){
        let found = false;
        f.forEach(function(field){
            if( field.type == "info" || field.type == "check" || field.type == "button" ){
              return
            }
            if( item[field.show] ){
                if(item[field.show].toString().toUpperCase().indexOf(s) > -1){
                  found = true
                  return
                }
            }
          });
        return found
      });
      this.UpdatePagination();
      this.updateUrl();
      t.stop()
    },
    highlight(word, query) {
      var check = new RegExp(query, "ig");
      return word.toString().replace(check, function(matchedText, a, b) {
        return '<span style="color:#c90000">' + matchedText + "</span>";
      });
    },
    orderBy: function(field){
      var t = this.timer("orderBy");
      if (this.isFieldSortable(field.show)) {
        if (this.sort.fieldName === field.show) {
         this.sort.order  = this.sort.order  === "asc" ? "desc" : "asc"
        } 
        else {
          this.sort.order = "desc"
          this.sort.fieldName = field.show
        }

        this.pagination.currentPage = 1

        var sf = (field.sort &&  field.sort.length > 0) ? field.sort : this.sort.fieldName + "_c"
        var sort_asc = this.sort.order  === "asc" ? 1 : 0

        this.sortedItems.sort(function(a, b) {
          let tmp_a = a[sf]
          let tmp_b = b[sf]
          if ( tmp_a === tmp_b) {
              return 0
          }
          else {
            if( tmp_a == parseInt(tmp_a, 10) && tmp_b == parseInt(tmp_b, 10) ){
              tmp_a = parseInt(tmp_a, 10)
              tmp_b = parseInt(tmp_b, 10);
            }  
            if( sort_asc == 1 ){ 
              return (tmp_a < tmp_b) ? -1 : 1
            }
            else{
              return (tmp_a > tmp_b) ? -1 : 1
            } 
            //return sort_bool(tmp_a , tmp_b, sort_asc);    
          }  
        }); 
        this.updateUrl()
        t.stop()
      }
    },
    isFieldSortable: function(field) {
      const foundHeader = this.fields.find(item => item.show === field);
      return foundHeader;
    },
    readUrl: function(){
      var t = this.timer("readUrl");
      if( this.$route.query["t" + this.tableId + "p"] ){
        var pageurl = parseInt(this.$route.query["t" + this.tableId + "p"]);
        if( Number.isInteger( pageurl ) ){
          this.pagination.currentPage = pageurl;
        }
      } 
      if( this.$route.query["t" + this.tableId + "sfn"]){
        this.sort.fieldName = this.$route.query["t" + this.tableId + "sfn"];
        this.sort.order = this.$route.query["t" + this.tableId + "sfo"];
      }

      if(this.$route.query["t" + this.tableId + "searchTerm"]){
        this.searchTermIntern = this.$route.query["t" + this.tableId + "searchTerm"];
      }      
      t.stop();
    },
    updateUrl: function(){
      var t = this.timer("updateUrl"); 
      let query = Object.assign({}, this.$route.query);

      query["t" + this.tableId + "p"] = this.pagination.currentPage;
      query["t" + this.tableId + "sfn"] = this.sort.fieldName;
      query["t" + this.tableId + "sfo"] = this.sort.order;

      if(this.searchTermIntern.length > 0 && this.searchTermIntern != this.searchTerm){
        query["t" + this.tableId + "searchTerm"] = this.searchTermIntern;  
      }
      else{
        delete query["t" + this.tableId + "searchTerm"];  
      }

      this.$router.replace({query}).catch(err => {});
      t.stop();
    }
  },
  watch: {
      filter(d) {
        var t = this.timer("watch filter");
        t.stop();
      },
      searchTerm() {
        var t = this.timer("watch searchTerm");
        this.searchTermIntern = this.searchTerm;
        t.stop();
      },
      searchTermIntern() {
        var t = this.timer("watch searchTermIntern");
        this.setFilter();
        t.stop();
      },
      items(){
        var t = this.timer("watch items");
        this.sortedItems = this.items.slice(0);
        this.rows = this.items.slice(0);

        this.UpdatePagination();
        var func = function (i, f) {
          i.forEach(function (item, num, index)  {
            f.forEach(function(field){
              if( item[field.show] ){
                // + c für compare bei orderby, falls eine suche aktiv ist und der text ein span vom highlight hat.
                item[field.show + '_c']  = item[field.show].toString().toLowerCase();

                item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00e4/g, "ae")
                item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00f6/g, "oe")
                item[field.show + '_c'] = item[field.show + '_c'].replace(/\u00fc/g, "ue")
              }
              else{
                item[field.show + '_c']  = '';  
              }
            });
          });
        };

        this.setFilter();
        t.stop();
        func(this.items, this.fields)
        t.stop(); 
        
      },
  },
  components: {
    Pagination
  }
};

function remove_first_character(element) {
  return element.slice(1)
}

function wrapInTag(opts){
  var tag = opts.tag || 'strong',
      words = opts.words || [],
      regex = RegExp(words.join('|'), 'gi'),
      replacement = '<'+ tag +'>$&</'+ tag +'>'

}
function sort_bool(a, b, sort_asc){
  if( a == parseInt(a, 10) && b == parseInt(b, 10) ){
    a = parseInt(a, 10);
    b = parseInt(b, 10); 
  }   
  if( sort_asc == 1 ){ 
    return (a < b) ? -1 : 1;
  }
  else{
    return (a > b) ? -1 : 1;
  }  
}

function convertHeaderName( show ){
  var words = show.split('_');
  words.forEach((num, index) => {
      return words[index] = words[index].charAt(0).toUpperCase() + words[index].slice(1)
  });
  return words.join(' ');
}
</script>

<style scoped>

.table-striped tbody tr:nth-of-type(even) {
    background-color: white;
}
.table-striped tbody tr:nth-of-type(odd) {
    background-color: #fcfcfc;
}
    
.table-hover tbody tr:nth-of-type(even):hover:not(.no-data) {
  background-color: rgba(0, 0, 0, 0.008);
}

.table-hover tbody tr:nth-of-type(odd):hover:not(.no-data) {
  background-color: rgba(0, 0, 0, 0.005);
}

.nowrap {
  white-space: nowrap;
}

tr.no-data td { 
  text-align: center;
  font-style: italic;
}

tr td span{
  padding: 0.35rem;
}

.ellipsis {
    position: relative;
}
.ellipsis:before {
    content: '&nbsp;';
    visibility: hidden;
}
.ellipsis span {
    position: absolute;
    left: 0;
    right: 0;
    top: 48%;
    transform: translateY(-48%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* table th:hover{
  background-color: #ededed;
} */

table{
  border-collapse: collapse;
  line-height: 1.5;
  text-align: left;
}

tr td.right, tr th.right{
  text-align: right;
}
    
tr td.center, tr th.center{
  text-align: center;
}

table td {
  border-bottom: 1px solid #dee2e6;
  vertical-align: middle;
}

table th{
  border-bottom: 1px solid #dee2e6;
  position: relative;
  /* border-left: 1px solid #d9dce0; */
  -ms-user-select: none; 
  -moz-user-select: none; 
  -webkit-user-select: none; 
  cursor: pointer;
  padding: 0 !important;
  vertical-align: bottom;
  cursor: default;
}
.table thead th {
  /* border-top: 1px solid #d9dce0;
  border-bottom: 1px solid #d9dce0; */
  font-weight: bold;
  padding: 0;
}


table th div.label{
  width: 100%;
  height: 100%;
  padding: 0.35rem !important;
  cursor: pointer;
}
table th div.label.isFiltered{
  padding-top: 0 !important;
  border-top: 0.35rem solid #007bff;
}


table th div.sortdiv{
  width: 10px;
  height: 0; 
  display: flex;
}

table th.right div.label{
  padding-right: 15px !important;
}

table th span:after{
  position: absolute;
  right: .25rem;
  bottom: 3px;
  display: inline-block;
  font-size: 1.3rem;
}

table th span.asc:after{
  content: '↑';
}
table th span.desc:after{
  content: '↓';
}
.table-bordered{
  border: none;
}
table td.button{
  padding: 0;
  cursor: pointer;
  min-width: 40px;
  width: 40px;
  font-size: 1.3rem;
}

table td.button div{
  margin: 1px 0;
  padding: 0;
  display: block;
  height: 25px;
}

/* table td.button:hover{
  background-color: #1F8CC4;   
  color: white;
} */
table td.button:hover div{
  background-color: #e3e3e3;
}
table td.button span{
  padding: 0;
  display: block;
}
.reportTable {
  min-width: 100%;
  flex-grow: 1;
  position: relative;
  /* overflow-y: auto; */  
}
.reportTableWrap {
  padding: 8px 12px 12px;
  border: 1px solid #e3e3e3;
  background-color: #fcfcfc;
}

.reportTableWrap.table-not-bordered{
  padding: 0;
  border: none;
  background-color: transparent; 
}

.reportTable{
  background-color: #fcfcfc;
}

.reportTable th {
  font-size: 0.95rem;
  /* background-image: linear-gradient( var(--tableHeaderBackground), var(--tableHeaderBackgroundDark)); */
  /* background-image: linear-gradient( var(--siemens-stone-ultr-light), var(--siemens-stone-light)); */
  /* background-color: #e8ecf0; */
}

.reportTitle th.minWidth180 {
  min-width: 180px;
}
.reportTitle th.minWidth80 {
  min-width: 80px;
}
.reportTitle th.minWidth200 {
  min-width: 200px;
}
.reportTitle th.minWidth220 {
  min-width: 220px;
}
.reportTitle th.minWidth100 {
  min-width: 100px;
}

.reportTable td {
  padding: 0.35rem;
  font-size: 0.95rem;
}

@media (max-width: 700px)
{
  .reportTableWrap{
    width: 620px;
  }
}

/* my ICONS */
.img-delete div{
  background: url(/static/img/icons/my_icons.png) no-repeat center 3px;
}
.img-delete div:hover{
  background-position: center -37px;
}

.img-edit div{
  background: url(/static/img/icons/my_icons.png) no-repeat center -77px;
}
.img-edit div:hover{
  background-position: center -117px;
}

th.rotate {
  /* Something you can count on */
  height: 140px;
  white-space: nowrap;
}

th.rotate > div {
  transform: skew(-45deg,0deg);
  width: 30px;
  position: relative;
  top: 0px;
  left: 70px;
  height: 100%;
}
span.c{
  padding-left: 0;
  padding-right: 0;
}
th.rotate > div > span {
  padding: 5px 10px;
  -ms-transform: skew(45deg,0deg) rotate(315deg);
    -moz-transform: skew(45deg,0deg) rotate(315deg);
    -webkit-transform: skew(45deg,0deg) rotate(315deg);
    -o-transform: skew(45deg,0deg) rotate(315deg);
    transform: skew(45deg,0deg) rotate(315deg);
    position: absolute;
    bottom: 20px;
    left: -15px;
    display: inline-block;
    width: 100%;
    width: 85px;
    text-align: left;
    white-space: nowrap;
}

.info{
  cursor: help;
}
.check{
  color: #4bad46;
}
.notcheck{
  color: #CB503F;
}
.check_load{
  color: #b8b8b8;
}

td.icon{
  padding: 0;
  font-size: 1.3rem;
}
        
</style>


// WEBPACK FOOTER //
// src/components/table/_BaseTable.vue